// extracted by css-extract-rspack-plugin
export default {"checkboxOutLook":"checkboxOutLook-FywFEM","checkedBorder":"checkedBorder-iX7Els"};